import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import {
  AccountDeletionStep1,
  AccountDeletionStep2,
  AccountDeletionStep3,
} from "@src/features/accountDeletion";
import { useDeleteUserAccount, useGetUserInfoMe } from "@src/entities/user";
import { WrapperLoading } from "@src/shared/components";

import styles from "./AccountDeletionPage.module.scss";
import { userАccountСhangesStore } from "@src/entities/user/model/store/userАccountСhangesStore";

export const AccountDeletionPage = () => {
  const [step, setStep] = useState<number>(1);
  const [isDisabledBtn, setIsDisabledBtn] = useState<boolean>(false);
  const [remainingSeconds, setRemainingSeconds] = useState<number>(0);

  const {
    isPending: isDeleteUserAccountLoading,
    isError: isDeleteUserAccountError,
  } = useDeleteUserAccount();

  const { isPending: isGetUserInfoMeLoading, isError: isGetUserInfoMeError } =
    useGetUserInfoMe();

  const clearInfo = userАccountСhangesStore((state) => state.clearInfo);

  useEffect(() => {
    return () => {
      clearInfo();
    };
  }, []);

  useEffect(() => {
    const blockUntil = localStorage.getItem("blockUntil");
    if (blockUntil) {
      const timeLeft = +blockUntil - Date.now();
      if (timeLeft > 0) {
        setIsDisabledBtn(true);
        setRemainingSeconds(Math.floor(timeLeft / 1000));
      } else {
        localStorage.removeItem("blockUntil");
      }
    }
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isDisabledBtn && remainingSeconds > 0) {
      interval = setInterval(() => {
        setRemainingSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsDisabledBtn(false);
            localStorage.removeItem("blockUntil");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isDisabledBtn, remainingSeconds]);

  const isLoading = isDeleteUserAccountLoading || isGetUserInfoMeLoading;
  const isError = isDeleteUserAccountError || isGetUserInfoMeError;

  return (
    <WrapperLoading isLoading={isLoading} isError={isError}>
      <Box className={`${styles.root} montserrat-font`}>
        <h1 className={styles.title}>Удалить аккаунт и все данные</h1>
        {step === 1 && (
          <AccountDeletionStep1
            setStep={setStep}
            setIsDisabledBtn={setIsDisabledBtn}
            setRemainingSeconds={setRemainingSeconds}
            isDisabledBtn={isDisabledBtn}
            remainingSeconds={remainingSeconds}
          />
        )}
        {step === 2 && <AccountDeletionStep2 setStep={setStep} />}
        {step == 3 && <AccountDeletionStep3 setStep={setStep} />}
      </Box>
    </WrapperLoading>
  );
};
